export const CONFIG = {
  logo: "/logo.png",
  site_title: "Connect IoT Management",
  Auth0Domain: "connectiot.eu.auth0.com",
  Auth0ClientId: "ZKYlPUdt2BfFxksFEnBCUZ2uu7LPJK7E",
  Auth0Audience: "https://manage-api.connect-iot.eu",
  API_URL: "https://manage-api.connect-iot.eu/",
  mapboxAccessToken:
    "pk.eyJ1IjoiYmZnbmVpbCIsImEiOiJjbGR2azExeW4wZ28yM29tZm4xZjJwdHFxIn0.Mdv--BkZwKSw-pdTRMQdPg",
  mapStyle: "mapbox://styles/bfgneil/clkha3odl008i01qpeqws6d21",
  websiteURL: "https://manage.connect-iot.eu",
  billingEnabled: false,
  deviceCost: 15,
  primaryColour: "#006633",
  secondaryColour: "#dcffee",
};
